/* eslint-disable react/no-danger */
import * as React from 'react';

import { CMLUtils, toPlainText } from '@coursera-web/cml';
import moment from 'moment';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import config from 'js/app/config';

import { clearEmptyFields } from 'bundles/seo/utils/utils';

class CDPReviewsSchemaMarkup extends React.Component {
  static propTypes = {
    CDPReviewsMetaData: PropTypes.object,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  declare context: LegacyContextType<typeof CDPReviewsSchemaMarkup.contextTypes>;

  createCanonicalCourseLink(slug: $TSFixMe) {
    return `${config.url.base}learn/${slug}`;
  }

  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'CDPReviewsMetaData' does not exist on ty... Remove this comment to see the full error message
      CDPReviewsMetaData: {
        aggregrateRating: { ratingScore, ratingCount, reviewCount },
        slug,
        courseName,
        courseDescription,
        partnerName,
        partnerLogoUrl,
        reviews,
      },
    } = this.props;

    const markupJson = {
      '@context': 'http://schema.org',
      '@type': 'Product',
      name: courseName,
      brand: partnerName,
      image: partnerLogoUrl,
      description: courseDescription,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: ratingScore,
        ratingCount,
        reviewCount,
        worstRating: 1,
        bestRating: 5,
      },
      offers: {
        '@type': 'Offer',
        url: this.createCanonicalCourseLink(slug),
        priceCurrency: 'USD',
        price: 0,
        availability: 'OnlineOnly',
        seller: {
          '@id': 'https://www.coursera.org/#organization',
          '@type': 'Organization',
          name: 'Coursera',
        },
      },
      review:
        reviews && reviews.length
          ? reviews.map((review: $TSFixMe) => ({
              '@type': 'Review',
              datePublished: moment(review.reviewedAt).format('YYYY-MM-DD'),
              reviewBody: toPlainText(CMLUtils.create(review.reviewText.cml.value, review.reviewText.cml.dtdId)),

              author: {
                '@type': 'Person',
                name: review.fullName,
              },

              reviewRating: {
                '@type': 'Rating',
                ratingValue: 5,
              },
            }))
          : '',
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(clearEmptyFields(markupJson))}
        </script>
      `,
    });

    return (
      <div className="rc-CDPReviewsSchemaMarkup">
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default CDPReviewsSchemaMarkup;
